import type { ReactNode, ReactElement } from 'react';
import { useCan } from './useCan';
import type { Permission } from './permissions';

type CanProps = {
  permission: Permission;
  children: ReactNode;
  fallback?: ReactNode;
};

export function Can({ permission, children, fallback = null }: CanProps): ReactElement {
  const allowed = useCan(permission);
  return <>{allowed ? children : fallback}</>;
}

export default Can;
